


import type React from "react";
import { motion } from "framer-motion";
import { useState,startTransition, useEffect, useCallback, useContext,useMemo,useRef } from "react";
import { Buttons } from "../../../../components/ui/button";
import { Badge } from "../../../../components/ui/badge";
import { ChevronLeft, ChevronRight } from "lucide-react";
import svgPaths from "../../../../imports/svg-knollny4nu";
import { API_SERVER } from 'config/constant';
import { ProfileContext } from '../EntirePreview';
import InteractionScreenShot from '../../demoplay/playcards/InteractionScreenShot';
import Scrollbar from 'components/customScroll/CustomScroll';
import InteractionScreenShotFutureTheme from '../FutureTheme/InteractionScreenShotFutureTheme';
import NewBackground_2 from '../../../../assets/glb/NewBackground_2.jpg'
import { feedbackdata } from 'utils/gameApplication/gamePlayService';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { useColor } from "../../../../components/ui/ColorContext";
import ReplayScoreFutureTheme from "./ReplayScoreFutureTheme";
import { Console } from "console";
import { useParams } from "react-router-dom";
import { activityUpdate } from "utils/gameApplication/gameActivityService";
import { updateScreenActivity } from "../common";
import { ScoreContext } from "../GamePreview";

// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};
  const NavigationArrow: React.FC<{
    direction: "left" | "right";
    onClick: () => void;
  }> = ({ direction, onClick }) => {
      const { primaryColor } = useColor();
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="w-[3.125rem] h-[2.125rem] py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${direction === "left" ? "275.041deg" : "90deg"
            },
            rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
              primaryColor
            )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
          boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
            primaryColor
          )}, 0.3)`,
        }}
      >
        {direction === "left" ? (
          <ChevronLeft className="!h-4 !w-4 text-white" />
        ) : (
          <ChevronRight className="!h-4 !w-4 text-white" />
        )}
      </Buttons>
    );
  };


interface FeedBackScreenShotProps {
   seconds?:any;
  setIsDoorEntry: (value: boolean) => void;
  setReplayIsOpen: (value: boolean) => void;
  handleReplayButtonClick?: (replayState: string) => void;
    replayNextHandler: any;
  getSelectedOptions?: any;
  backgroundScreenUrl: any;
  currentScreenId: any;
  isScreenshot: any;
  FeedbackremainingSentences?: any;
  options: any;
  getData: any;
  data: any;
  FeedBackselectedoptionData?: any;
  FeedBackoptionData?: any;
  feed?: any;
  getFeedbackData?: any;
  profile: any;
  setisScreenshot: any;
  preloadedAssets: any;
  FeedbackcurrentPosition?: any;
  interactionBlockArray?: any;
  profileData?: any;
  setFeedbackCurrentPosition?: any;
  setCurrentScreenId?: any;
  gameInfo?: any;
  setAudioObj?: any;
  firstLoading: any;
  setFirstLoading: any;
  InterActionScore?: any;
  setCurrentQuestNo?: any;
  NonPlayerNameLanguage?: any;
audioObj?:any;
    handleScenarioReplayButtonClick:any;
    sceneriowiseHighestEarnedScore: any;
    sceneriowiseEarnedScore:any;
    scenarioTotalScore:any;
    scenarioAllTimeScore:any;
        scenarioMinScore:any;
  setScenarioMinScore:any;
  scenarioDistinctionScore:any;
  setScenarioDistinctionScore:any;
  learnerPlayList: any;
  setLearnerPlayingDetails: any;
  setprevBlock: any;
  prevBlock: any;
  demoBlocks: any;
  setProfile: any;
  questState: any;
  setOptions: any;
  setType: any;
  setData: any;
 audioCache: any;
  audioReady: boolean;
   Activitydata?:any;
   scenariowisebestscore1:any;
   AssignId:any
}
const CompletionFeedBackScreenFutureTheme: React.FC<FeedBackScreenShotProps> = ({
   sceneriowiseHighestEarnedScore,
   seconds,
    scenarioMinScore,
    setIsDoorEntry,
    getData,
  setScenarioMinScore,
  scenarioDistinctionScore,
  setScenarioDistinctionScore,
Activitydata,
  backgroundScreenUrl,
  profile,
  isScreenshot,
  setisScreenshot,
  data,
  getSelectedOptions,
  FeedbackremainingSentences,
  options,
  currentScreenId,
  FeedBackselectedoptionData,
  FeedBackoptionData,
  setReplayIsOpen,
  handleReplayButtonClick,
  replayNextHandler,
  getFeedbackData,
  preloadedAssets,
  FeedbackcurrentPosition,
  interactionBlockArray,
  profileData,
  setFeedbackCurrentPosition,
  setCurrentScreenId,
  gameInfo,
  setAudioObj,
  // setFirstLoading,
  // firstLoading,
  InterActionScore,
  setCurrentQuestNo,
  NonPlayerNameLanguage,
audioObj,
    handleScenarioReplayButtonClick,
    sceneriowiseEarnedScore,
    scenarioTotalScore,
    scenarioAllTimeScore,
    learnerPlayList,
  setLearnerPlayingDetails,
  prevBlock, setprevBlock,
  demoBlocks,
  setProfile,
  questState,
  setOptions,
  setType,
  setData,
  scenariowisebestscore1,
  audioCache, audioReady,
  AssignId

}) => {
 const {setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
const { learner_game_play_id } = useParams();
 const bestAllTimeScore = Array.isArray(scenarioAllTimeScore)
    ? Math.max(
        ...scenarioAllTimeScore.filter(
          (s: number) => typeof s === 'number' && s > 0
        ),
        0
      )
    : 0;

  // final score used for stars & competency
  const effectiveScore =
    bestAllTimeScore > 0
      ? Math.min(bestAllTimeScore, scenarioTotalScore)
      : sceneriowiseEarnedScore;

  
  const [minimumScore,setminimumScore] = useState(scenarioMinScore)

  useEffect(()=>{
    setminimumScore(scenarioMinScore)
  },[setScenarioMinScore])
//new by kaviya 
const audioRef = useRef<HTMLAudioElement | null>(null);
useEffect(() => {
  if (audioObj?.url && audioRef.current) {
    const audio = audioRef.current;

    audio.pause();
    audio.currentTime = 0;

    audio.src = audioObj.url;
    audio.load();

    audio.play()
      .then(() => {
      
      })
      .catch((err:any) => {
      
      });
  }
}, [audioObj?.url]);

  const [showReplayPopup, setShowReplayPopup] = useState(false);
  const earnedScore = sceneriowiseEarnedScore;
const totalScore = scenarioTotalScore;
const minScore = minimumScore;
 const totalScore1 = scenariowisebestscore1;


const remainingToFull = Math.max(totalScore - totalScore1, 0);

  const isBelowMin = totalScore1 < minScore;
  const isPerfectScore = totalScore1 === totalScore;


const getPopupMessage = () => {
 
  if (isBelowMin) {
    return `You need to earn ${minScore - totalScore1} more points to reach the minimum score. Replay is required.`;
  }

  if (isPerfectScore) {
    return `Would you like to replay this scenario?`;
  }

  return `You’re almost there! Earn ${remainingToFull} more points to achieve a perfect score.`;
};
  const getCachedAudio = (path: any) => {
    if (!path) return null;
    const cachedUrl = audioCache[path];
    if (!cachedUrl) {
      console.warn("Audio not preloaded:", path);
      return null;
    }
    return new Audio(cachedUrl);
  };
const scenarioSource =
  data?.blockScenario || data?.scScenarioLevel;

const scenarioNumber =
  typeof scenarioSource === "string"
    ? Number(scenarioSource.replace(/\D/g, ""))
    : scenarioSource;

const isScenarioOne = scenarioNumber === 1;


useEffect(() => {
  setShowReplayPopup(false);
}, [scenarioSource]);




const handlePopupNext = async() => {
    setlearnerActivityrec((prev:any)=>
  updateScreenActivity(
    prev,
    99,
    "Replay Prompt",
    deviceInfo,
    {
      replyPromptopen:true,
      replyPromptclose:true,
      promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
      replayplayaction : false
    }
  )
);
  setShowReplayPopup(false);
    let total = 0;
  let updatedscore: any = [];
  if (questState[parseInt(profile?.currentQuest)] === 'Started') {
    // Remove matching object from profile?.score
    updatedscore = profile?.score;
  } else if (
    questState[parseInt(profile?.currentQuest)] === 'replayallowed'
  ) {
    // Remove matching object from profile?.replayScore
    updatedscore = profile?.replayScore;
  } else {
    updatedscore = profile?.score;
  }
  const scoreArray = updatedscore;
  if (scoreArray?.length > 0) {
    // STEP 2: Apply filter with logs
    const filteredData = scoreArray?.filter((cur: any, index: number) => {
      const isValidStructure =
        cur.seqId &&
        cur.scenarioId !== undefined &&
        cur.choosedoption !== undefined;

      const isQuestMatch = Number(cur.quest) === Number(profile.currentQuest);

      const finalResult = isValidStructure && isQuestMatch;

      return finalResult;
    });

    // STEP 3: Reduce with logs
    total = filteredData?.reduce((sum: number, cur: any, index: number) => {
      const score = Number(cur.score || 0);

      return sum + score;
    }, 0);
  }
  // let upcomingBlock: any;
  let upcomingBlock: any = data;
  // const currentQuest = data
  //     ? parseInt(data?.blockPrimarySequence.split('.')[0])
  //     : null;
    // const selectedNext = Object.keys(demoBlocks[currentQuest])
    //         .filter((item: any) => {
    //           return (
    //             demoBlocks[currentQuest][item]?.blockSecondaryId ===
    //             parseInt(data?.blockLeadTo)
    //           );
    //         })
    //         .map((item: any) => {
    //           return demoBlocks[currentQuest][item];
    //         });
    //            console.log("selectedNext= data =>",selectedNext)
    //   // ✅ manually selected block
    //   if (selectedNext && selectedNext.length > 0) {
    //     upcomingBlock = selectedNext[0];
    //   }else{
    //         upcomingBlock = data;
        
    //   }
  

 
  const updatedata = {
    blockname: upcomingBlock.blockChoosen,
    galAverageScore: total,
    galBlockId: upcomingBlock.blockSecondaryId,
    galblockleft : upcomingBlock.blockSecondaryId,
    galTimeSpent: seconds,
    gameId: learner_game_play_id,
    galAssignedId:AssignId,
  };
  const actId1 = Activitydata;
  const datas = JSON.stringify(updatedata);
  const result = await activityUpdate(datas, actId1);
  if (result.status !== 'Success') {
    return false;
  }
   setData(upcomingBlock)
  setType(upcomingBlock?.blockChoosen)
     if (upcomingBlock?.blockChoosen === 'Interaction') {
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
          if (
            option?.qpSequence ===
            upcomingBlock?.blockPrimarySequence
          ) {
            optionsFiltered.push(option);
          }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }
      setOptions(optionsFiltered);
    }
  // getData(data)
  setCurrentScreenId(2)
  setIsDoorEntry(false)
  // onScenarioLeaderboardNext(); // existing next flow
};


  const { primaryColor } = useColor();
  // new
  const [interactionquestionData, setInteractionquestionData] = useState({
    interactionoptionsfeedback: [],
    interactionquestion: [],
    questoptionchoose: [],
    interactionalphapets:[],
    interactionoptions: [],

  });
  const [currentInteractionIndex, setCurrentInteractionIndex] = useState(0);
  
  const [firstLoading, setFirstLoading] = useState<boolean>(true);
  const [fetchCount, setFetchCount] = useState(0);
  const [replayState, setReplayState] = useState<null | string>(null);

 
  const feedbacklength = interactionquestionData?.interactionoptionsfeedback?.length;
  const [QuestContentByLanguage, setQuestContentByLanguage] = useState(null);
  const [FeedbackPositionStatus, setFeedbackPositionStatus] = useState<boolean>(false);
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
  const useData = useContext(ProfileContext);

  const [animateDialog, setAnimateDialog] = useState<boolean>(false);
  const [showTypingEffect, setShowTypingEffect] = useState<any>(false);

  const geTfeedBackoption = () => {
    setisScreenshot(false);

  };
  useEffect(() => {
    if (FeedbackPositionStatus === true) {
      setFeedbackPositionStatus(false);
    }
  }, []);
  //useEffect(() => {
  //  if (isScreenshot === false) {


   //   feedBackAudioPlay();
 //   }
 //   else {
 //     setAudioObj((prev: any) => ({
   //     ...prev,
   //     url: '',
   //     type: EnumType.VOICE,
  //      loop: false, // Voice doesn't loop
  //      autoplay: true, // Autoplay is disabled
   //   }));
  //  }

  //}, [isScreenshot]);
  
  
  useEffect(() => {
  if (
    interactionquestionData?.interactionalphapets?.length > 0 &&
    interactionquestionData?.interactionoptions?.length > 0
  ) {
    feedBackAudioPlay();
  }
}, [currentInteractionIndex, interactionquestionData]);

  const fetchinteraction = async () => {
    const data2 = {
      gameId: gameInfo.gameData.gameId,
      // questNo: gameInfo.gameData.gameQuestNo,
      questNo: profile.currentQuest,
       activityId:Activitydata
    };

    try {
      const result = await feedbackdata(JSON.stringify(data2));
      if (result.status === "Success") {
        setInteractionquestionData(result.data || "check backedn data");
      }
    }
    catch (error) {
      console.error("Error saving interaction", error);
    }
  };

  const totalInteractions =
    Math.min(
      interactionquestionData.interactionquestion.length,
      interactionquestionData.interactionoptions.length,
      interactionquestionData.interactionoptionsfeedback.length
    );
  const hasNextInteraction = currentInteractionIndex + 1 < totalInteractions;
  const getFeedbackData1 = (data?: any) => {
    setisScreenshot(true);
  };


    type InteractionAlphabet = {
    option: string;
    qpQuestionId: number;
  };

  type FeedbackAudio = {
    qpQuestionId: number;
    qbfeedbackAudioUrl: string;
  };
  const feedBackAudioPlay = async () => {
    if (interactionquestionData.questoptionchoose.length !== 0 &&
      profileData?.Audiogetlanguage.length === 0) {

     
      const alpha: InteractionAlphabet =
        interactionquestionData.interactionalphapets[currentInteractionIndex];

      if (!alpha) return;
      const option = interactionquestionData.interactionoptions.find(
        (opt: any) =>
          opt.blockId === alpha.qpQuestionId &&
          Array.isArray(opt.optionsdetails?.qpOptions) &&
          opt.optionsdetails.qpOptions.includes(alpha.option)
      );

     
      if (!option) return;

      // 🛡️ GUARD AGAIN (IMPORTANT)
      const qpOptions = option.optionsdetails?.qpOptions;
      const feedbackAudios = option.optionsdetails?.qbfeedbackAudioUrl;

      if (!Array.isArray(qpOptions) || !Array.isArray(feedbackAudios)) {
        console.warn('Options or audios missing', option.optionsdetails);
        return;
      }

      // 1️⃣ Find index safely
      const optionIndex = qpOptions.indexOf(alpha.option);

      if (optionIndex === -1) {
        console.warn('Selected option not found in qpOptions');
        return;
      }

      // 2️⃣ Get matching audio
      const matchedAudio = feedbackAudios[optionIndex];

      if (!matchedAudio) {
        console.warn('No feedback audio found for index:', optionIndex);
        return;
      }

      // 3️⃣ Final result
      const FindUrl: FeedbackAudio[] = [
        {
          qpQuestionId: alpha.qpQuestionId,
          qbfeedbackAudioUrl: matchedAudio,
        },
      ];
     
      if (FindUrl?.length > 0) {
        // try {
        //   const optionFeedBackAudio = FindUrl[0]?.qbfeedbackAudioUrl ? FindUrl[0]?.qbfeedbackAudioUrl : '';
        //  if (optionFeedBackAudio !== '') {
        //     // const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
        //     const fullUrl = getCachedAudio(optionFeedBackAudio);
        //     // const responseblockText = await fetch(fullUrl);
        //     if (fullUrl) {
        //       setAudioObj((prev: any) => ({
        //         ...prev,
        //         url: fullUrl.src,
        //         type: EnumType.VOICE,
        //         loop: false, // Voice doesn't loop
        //         autoplay: true, // Autoplay is disabled
        //       }));
        //     }
        //   }

        //   // if (optionFeedBackAudio !== '') {
        //   //   const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
        //   //   const responseblockText = await fetch(fullUrl);
        //   //   if (responseblockText.ok) {
        //   //     setAudioObj((prev: any) => ({
        //   //       ...prev,
        //   //       url: fullUrl,
        //   //       type: EnumType.VOICE,
        //   //       loop: false, // Voice doesn't loop
        //   //       autoplay: true, // Autoplay is disabled
        //   //     }));
        //   //   }
        //   // }
        // } catch (error) {
        //   console.error('Error fetching data:', error);
        // }
         try {
          const optionFeedBackAudio = FindUrl[0]?.qbfeedbackAudioUrl ? FindUrl[0]?.qbfeedbackAudioUrl : '';
         

          if (optionFeedBackAudio !== '') {
           

            const fullUrl = `${API_SERVER}${optionFeedBackAudio}?t=${Date.now()}`;

setTimeout(() => {
  setAudioObj((prev: any) => ({
    ...prev,
    url: fullUrl,
    type: EnumType.VOICE,
    loop: false,
    autoplay: true,
  }));
}, 50);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    }
    else {
      if (profileData?.Audiogetlanguage.length !== 0) {
        const FindUrl = options?.filter((item: any) => FeedBackselectedoptionData === item?.qpOptions)

        if (FindUrl.length > 0) {
          const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
            (key: any) => key?.textId === FindUrl[0]?.qpOptionId,
          );
          if (optionAudioFiltered.length > 0) {
            const getoptionsAudioFiltered = optionAudioFiltered.filter(
              (key: any) => key?.fieldName === 'qpFeedback',
            );
            if (getoptionsAudioFiltered.length > 0) {
              try {
                const QOTaudioUrls = getoptionsAudioFiltered[0]?.audioUrls ? getoptionsAudioFiltered[0]?.audioUrls : '';
                if (QOTaudioUrls !== '') {
                  const qpOptionTextUrl = `${API_SERVER}${QOTaudioUrls}`;
                  const responseqpOptionText = await fetch(qpOptionTextUrl);
                  if (responseqpOptionText.ok) {
                    setAudioObj((prev: any) => ({
                      ...prev,
                      url: qpOptionTextUrl,
                      type: EnumType.VOICE,
                      // volume: '0.5',
                      loop: false,
                      autoplay: true,
                    }));
                  }
                }
              } catch (error) {
                console.error('Error fetching data:', error);
              }
            }
          }

        }

      }
    }
  }

  const setAudioForfeedBack = () => {
    if (profileData?.Audiogetlanguage.length !== 0) {
      const GetblocktextAudioFiltered =
        profileData?.Audiogetlanguage.filter(
          (key: any) => key.textId === FeedBackoptionData[0].blockId,
        );

      if (GetblocktextAudioFiltered.length > 0) {
        const Filteredcontent = GetblocktextAudioFiltered.filter(
          (item: any) => item?.fieldName === 'blockText',
        );

        setQuestContentByLanguage(Filteredcontent[0]?.content ? Filteredcontent[0]?.content : null);
      }
    }
  }
  useEffect(() => {
    if (FeedBackoptionData !== null) {
      if (FeedBackoptionData[0]?.blockId) {
        setAudioForfeedBack();
      }
    }
  }, [FeedBackoptionData]);

  const previousScreen = () => {
    const setPositionForFeedBack = FeedbackcurrentPosition === 1 ? FeedbackcurrentPosition - 1 : FeedbackcurrentPosition > 1 ? FeedbackcurrentPosition - 2 : null;

    // if (setPositionForFeedBack !== null && FeedbackcurrentPosition !== 1) {
    //   setFeedbackCurrentPosition(setPositionForFeedBack);
    //   setFeedbackPositionStatus(true)
    //   return;
    // }
      if (currentInteractionIndex > 0) {
              setisScreenshot(true);
              setCurrentInteractionIndex(prev => prev - 1);
            }
    else {
      setFeedbackCurrentPosition(0);
      // if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
      if (data?.scLeaderBoardEnabled === 'true') {
        setCurrentScreenId(2); //Navigate to leaderboard
        return false;
      }
      else {
        // const LastquestNo = parseInt(profile.currentQuest);
        // setCurrentQuestNo(LastquestNo);
        // setCurrentScreenId(2);
        // // setCurrentScreenId(13);
        // return false;
        const questNo = profile?.currentQuest;
      // const Prevquestseq =learnerPlayList?.Prevquestseq[playingQuest];
      const lastSeq = learnerPlayList?.Prevquestseq[questNo];
      let updateNavigateSeq: any = [...learnerPlayList?.Prevquestseq[questNo]];

      updateNavigateSeq.pop();
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        Prevquestseq: { ...prev.Prevquestseq, [questNo]: updateNavigateSeq }
      }));

      let prev = prevBlock.length > 0 ? prevBlock[prevBlock.length - 1] : lastSeq ? lastSeq[lastSeq.length - 1] : null;


      let getBlocks: any;
      if (prev) {
        getBlocks = Object.values(demoBlocks[questNo]).filter((item: any) => item?.blockPrimarySequence === prev);
        if (prevBlock.length === 0 && updateNavigateSeq.length > 0) {
          setprevBlock(updateNavigateSeq);
        }
        prevBlock.pop();
        startTransition(() => {
          setData(getBlocks[0]);
          setType(getBlocks[0]?.blockChoosen);
          if (
            getBlocks[0]?.blockChoosen ===
            'Interaction'
          ) {
            const optionsFiltered = [];
            const primarySequence = getBlocks[0].blockPrimarySequence;

            for (const option of gameInfo.questOptions) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (option?.qpSequence === primarySequence) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );

                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (option?.qpSequence === primarySequence) {
                  optionsFiltered.push(option);
                }
              }
            }
            if (gameInfo?.gameData?.gameShuffle === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ];
              }
            }
            setOptions(optionsFiltered);
          }
          if (questState && questState[profile?.currentQuest]) {
            if (questState[profile?.currentQuest] !== 'Started') {
              setProfile((prev: any) => ({
                ...prev,
                replayScore: profile.score,
              }));
            }
          }

          setCurrentScreenId(2);
        });
        return false;
      }
      else {
        startTransition(() => {
          setCurrentScreenId(13);
        })
      }
      }
    }
  }

  useEffect(() => {
    if (FeedbackPositionStatus === true) {
      getFeedbackData();
      setFeedbackPositionStatus(false);
    }
  }, [FeedbackPositionStatus]);

  useEffect(() => {
    setAnimateDialog(false)
  }, [firstLoading, showTypingEffect]);


  const Updatecontent = () => {
    useData?.setMotionEffect(true);
    setTimeout(() => {
      useData?.setMotionEffect(false);
    }, 1000)

    setAnimateDialog(true)
    setTimeout(() => {
      setFirstLoading(false);
      // setisScreenshot(true);
      // fetchinteraction();
      setFetchCount(Date.now());
    }, 500)

  };
  useEffect(() => {
    if (fetchCount === 0) return;

    fetchinteraction();
    setisScreenshot(true);
  }, [fetchCount]);



  const handleNext = () => {
  if (hasNextInteraction) {
    setCurrentInteractionIndex(prev => prev + 1);
    setisScreenshot(true);
  } else {
      setlearnerActivityrec((prev:any)=>
          updateScreenActivity(
            prev,
            99,
            "Replay Prompt",
            deviceInfo,
            {
              replyPromptopen:true,
              replyPromptclose:false,
              promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
              replayplayaction : false
            }
          )
        );
    // LAST feedback → open replay popup
    setisScreenshot(false);
    setShowReplayPopup(true);   // ✅ THIS IS THE KEY
  }
};


  const playClickSound = () => {
      try {
        const audio = new Audio(BtnClickSound as string);
        audio.volume = 1;
        audio.play().catch(() => { });
  
        setTimeout(() => {
          audio.pause();
          audio.currentTime = 0;
        }, 1000);
      } catch (e) {
        // ignore audio errors
      }
    };

  // Selected option feedback (from options array) — prefer this when available
  const selectedOptionFeedback = (() => {
    try {
      const found = options?.find((item: any) => item?.qpOptions === FeedBackselectedoptionData);
      return found?.qpFeedback || found?.feedback || null;
    } catch (e) {
      return null;
    }
  })();
  const QuestbackgroundGlb = useMemo(() => {
    
    const getCurrentQuest = parseInt(profile.currentQuest);
    const currentQuesTGameData = gameInfo?.gameQuest.find(
      (item: any) =>
        parseInt(item?.gameQuestNo) === getCurrentQuest
    );

    if (!currentQuesTGameData?.gameBackgroundId) return null;

    const matchedGlb:any = Object.values(preloadedAssets?.preloadedGLBs).find(
      (item: any) =>
        String(item.uniqueId) === String(currentQuesTGameData.gameBackgroundId)
    );

    return matchedGlb?.src || NewBackground_2;
  }, [gameInfo?.gameQuest, profile.currentQuest]);
  return (
    <>
      {firstLoading === false ?
        <>
          <div
            className="relative w-full h-screen bg-no-repeat bg-center bg-cover "
             style={{ backgroundImage: `url(${QuestbackgroundGlb})` }}
        
          >
            <div className="w-full px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6 lg:pb-8 relative h-full flex">

              {/* Dialogue Content */}
              <div className="h-full w-[45%]  flex flex-col justify-center items-start pt-24">
                <div
                  className="flex flex-col gap-5 max-h-fit max-w-xl overflow-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-6 pt-5 pb-6 backdrop-blur backdrop-blur-[3.724rem]"
                  style={{
                    background: `linear-gradient(21deg, rgba(0, 0, 0, 0.80) -10.76%, rgba(${hexToRgb(
                      primaryColor
                    )}, 0.2) 127.18%)`,
                  }}
                >
                  {/* Feedback Title */}
                  <div className="relative">
                    <h1
                      className="text-4xl font-normal tracking-[0.005rem] text-center"
                      style={{
                        color: primaryColor,
                        textShadow: `rgba(${hexToRgb(
                          primaryColor
                        )}, 0.5) 0px 0px 10px`,
                      }}
                    >
                      Feedback
                    </h1>
                  </div>

                  {/* Decorative Line */}
                  <div className="flex items-center justify-center relative w-full">
                    <div
                      onClick={() => setisScreenshot(true)}
                      className="flex items-center gap-2 text-3xl font-normal tracking-[0.005rem] text-center absolute"
                      style={{ top: '17%', zIndex: 10, color: 'white', cursor: 'pointer', marginTop: '1rem' }}
                    >
                      Interaction{" "}
                     
                      {currentScreenId === 14 && totalInteractions > 0 && (
                        <span>
                          {currentInteractionIndex + 1}/{totalInteractions}
                        </span>
                      )}
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" />

  {/* The "i" line */}
  <line
    x1="12"
    y1="10"
    x2="12"
    y2="16"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
  />

  {/* The dot of the "i" */}
  <circle cx="12" cy="7" r="1" fill="white" />
</svg>

</div>

                    <div className="w-full">
                      <div className="h-[1px] relative w-full">
                        <svg
                          className="block w-full h-[1px]"
                          fill="none"
                          preserveAspectRatio="none"
                          viewBox="0 0 537 1"
                        >
                          <line
                            stroke={`url(#paint0_linear_feedback_${primaryColor.replace(
                              "#",
                              ""
                            )})`}
                            strokeWidth="0.894962"
                            x2="537"
                            y1="0.552519"
                            y2="0.552519"
                          />
                          <defs>
                            <linearGradient
                              gradientUnits="userSpaceOnUse"
                              id={`paint0_linear_feedback_${primaryColor.replace(
                                "#",
                                ""
                              )}`}
                              x1="537"
                              x2="0"
                              y1="0.999899"
                              y2="0.99992"
                            >
                              <stop stopColor={primaryColor} stopOpacity="0" />
                              <stop
                                offset="0.484375"
                                stopColor={primaryColor}
                                stopOpacity="0.994792"
                              />
                              <stop
                                offset="1"
                                stopColor={primaryColor}
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <br/>

                  {/* Feedback Content */}

                  <div className="flex-1 w-full flex items-center justify-center px-1 max-h-[500px] overflow-y-auto relative">
                    <div className="w-full max-w-4xl mx-auto">
                     
                      <div className="w-full font-rubik font-normal text-[1.188rem] tracking-[-0.007rem] leading-[1.875rem] text-white">
                       
                        <p className="block transition-all duration-300">
                         
                          {
                            interactionquestionData.interactionoptionsfeedback[currentInteractionIndex]?.qpFeedback

                          }

                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Navigation */}
                  <div className="flex justify-between items-center w-full">
                    <NavigationArrow
                      direction="left"
                      onClick={() => previousScreen()}
                    />
                    <NavigationArrow
                      direction="right"
                      // onClick={() => getFeedbackData?.(data)}
                      onClick={handleNext}
                    />
                  </div>



                  {/* Inset Shadow Border */}
                  <div
                    className="absolute inset-0 pointer-events-none rounded-[2.375rem]"
                    style={{
                      boxShadow: `0px 0px 11px 0px inset rgba(${hexToRgb(
                        primaryColor
                      )}, 0.3), 0px 0px 20px 0px rgba(${hexToRgb(
                        primaryColor
                      )}, 0.2)`,
                    }}
                  />
                </div>
              </div>



            </div>

   <div className="absolute right-16 top-1/2 -translate-y-1/2 z-20 w-[50%]  flex justify-center">

             {isScreenshot  && (
                        <>
                         {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <InteractionScreenShot
                          data={FeedBackoptionData ?? ''}
                          option={FeedBackselectedoptionData ?? ''}
                          options={options ?? ''}
                          backGroundImg={backgroundScreenUrl}
                          geTfeedBackoption={geTfeedBackoption}
                          isScreenshot={isScreenshot}
                          preloadedAssets={preloadedAssets}
                          profileData={profileData}
                          currentScreenId={9}
                          QuestContentByLanguage={QuestContentByLanguage}
                          gameInfo={gameInfo}
                          InterActionScore={InterActionScore}
                          NonPlayerNameLanguage={NonPlayerNameLanguage}
                        />
                         ):(
             <InteractionScreenShotFutureTheme
                    currentInteractionIndex={currentInteractionIndex}
                    interactionquestionData={interactionquestionData}
                          data={FeedBackoptionData ?? ''}
                          option={FeedBackselectedoptionData ?? ''}
                          options={options ?? ''}
                          backGroundImg={backgroundScreenUrl}
                          geTfeedBackoption={geTfeedBackoption}
                          isScreenshot={isScreenshot}
                          preloadedAssets={preloadedAssets}
                          profileData={profileData}
                          currentScreenId={9}
                          QuestContentByLanguage={QuestContentByLanguage}
                          gameInfo={gameInfo}
                          InterActionScore={InterActionScore}
                          NonPlayerNameLanguage={NonPlayerNameLanguage}
                          QuestbackgroundGlb={QuestbackgroundGlb}
                        />
                         )}
                         </>
                      )
                      }
                       </div>
                      </div>
  
        </>
        :
        <>
         <div className="relative w-full h-screen overflow-hidden bg-no-repeat bg-center bg-cover"
           style={{ backgroundImage: `url(${QuestbackgroundGlb})` }}
         >

  <div className="w-full h-full flex flex-col justify-end px-4 sm:px-6 lg:px-10">

    {/* DIALOGUE BOX */}
    <div
      className="relative w-full  mx-auto rounded-2xl px-6 backdrop-blur-3xl"
  
                            style={{
                    background: `linear-gradient(21deg, rgba(0, 0, 0, 0.40) -10.76%, rgba(${hexToRgb(
                      primaryColor
                    )}, 0.2) 127.18%)`,
                 
                       
        paddingTop:'0rem',
        paddingBottom:"1rem",
                        }}
      
    >
      <div className="flex gap-12">

      
       

        {/* RIGHT — DIALOGUE TEXT */}
        <div className="flex-1 relative">

          {/* Light Glow Effects */}
          <div
            className="absolute w-80 h-80 -top-32 right-10 rounded-full blur-[200px] opacity-25 mix-blend-screen"
            style={{ background: primaryColor }}
          />

          <div
            className="absolute w-80 h-80 -top-40 left-10 rounded-full blur-[200px] opacity-15 mix-blend-screen"
            style={{ background: primaryColor }}
          />

          {/* TEXT BLOCK */}
          <p
            className="font-rubik text-[1.17rem] leading-8 text-white min-h-[6rem] 
                       overflow-y-auto cursor-pointer hover:opacity-90"
           
            style={{marginTop:'1rem',maxHeight:'10rem'}}
          >
                                {/* Let’s now see how you performed! You’ll first get a quick glance at your choice. Close the screenshot to unlock your feedback. */}
                                Let’s now see how you performed. You’ll see a screenshot on the side with your selected choice highlighted in blue. Please scroll if the selection is not visible.
          </p>

        </div>
      </div>

    
      <div className="flex justify-end items-center w-full">

                   
                    <NavigationArrow
                      direction="right"
                      
                      // onClick={() => getFeedbackData(data)}
                      onClick={() => Updatecontent()}
                    />
                  </div>

      {/* NEON BORDER GLOW */}
      <div
        className="absolute inset-0 rounded-2xl pointer-events-none"
        style={{
          boxShadow: `
            inset 0px 0px 12px rgba(${primaryColor},0.3),
            0px 0px 22px rgba(${primaryColor},0.2)`
        }}
      />

    </div>
  </div>
</div>

        </>


      }
     
 {showReplayPopup && (
        
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="relative w-full max-w-lg overflow-hidden rounded-3xl p-6 backdrop-blur-[2.5rem]"
          >
            <div className="relative flex flex-col items-center justify-end gap-8">
              {/* Main Content */}
              <div className="flex w-full flex-col gap-6">
                {/* Title */}
                <div
                  className="text-center text-4xl font-normal tracking-[0.005rem]"
                  style={{
                    color: primaryColor,
                    textShadow: `rgba(${hexToRgb(primaryColor)},0.5) 0px 0px 9px`,
                  }}
                >
                  <p>Scenario Review</p>
                </div>
        
                {/* Decorative Line */}
                <div className="relative flex h-[1px] w-full items-center justify-center">
                  <div className="w-full rotate-[179.99deg] scale-y-[-1]">
                    <svg
                      className="block h-[1px] w-full"
                      fill="none"
                      preserveAspectRatio="none"
                      viewBox="0 0 525 1"
                    >
                      <line
                        stroke={`url(#paint0_linear_review_${primaryColor.replace(
                          '#',
                          '',
                        )})`}
                        strokeWidth="0.894962"
                        x2="524.592"
                        y1="0.552519"
                        y2="0.552519"
                      />
                      <defs>
                        <linearGradient
                          gradientUnits="userSpaceOnUse"
                          id={`paint0_linear_review_${primaryColor.replace('#', '')}`}
                          x1="524.592"
                          x2="0"
                          y1="0.999899"
                          y2="0.999919"
                        >
                          <stop stopColor={primaryColor} stopOpacity="0" />
                          <stop
                            offset="0.484375"
                            stopColor={primaryColor}
                            stopOpacity="0.994792"
                          />
                          <stop stopColor={primaryColor} stopOpacity="0" offset="1" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
        
                {/* Content Text */}
                <div className="z-10 max-h-44 overflow-auto text-center font-rubik text-[1.188rem] font-normal leading-[2.125rem] -tracking-[0.005rem] text-white">
                  {getPopupMessage()}
                </div>
              </div>
        
              {/* Action Buttons */}
              <div className="relative z-10 flex w-full gap-4">
                <Buttons
                  onClick={() =>{
                    handleScenarioReplayButtonClick(
                      isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
                      data.blockScenario,
                    );
                     setlearnerActivityrec((prev:any)=>
                        updateScreenActivity(
                          prev,
                          99,
                          "Replay Prompt",
                          deviceInfo,
                          {
                            replyPromptopen:true,
                            replyPromptclose:true,
                            promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
                            replayplayaction : true
                          }
                        )
                      );
                  }
                  }
                  variant="ghost"
                  size="sm"
                  className="font-rubik h-12 flex-1 rounded-[2.5rem] px-4 py-2 text-lg font-medium tracking-[0.034rem] text-white transition-all duration-200 hover:scale-110"
                  style={{
                    background: `linear-gradient(100deg, rgba(${hexToRgb(
                      primaryColor,
                    )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                    border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                    boxShadow: `0px 0px 21.786px rgba(${hexToRgb(
                      primaryColor,
                    )}, 0.4)`,
                  }}
                >
                  Replay
                </Buttons>
        
                {!isBelowMin && (
                  <Buttons
                    onClick={handlePopupNext}
                    variant="ghost"
                    size="sm"
                    className="font-rubik h-12 flex-1 rounded-[2.5rem] px-4 py-2 text-lg font-medium tracking-[0.034rem] text-white transition-all duration-200 hover:scale-110"
                    style={{
                      background: `rgba(${hexToRgb(primaryColor)}, 0.15)`,
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`,
                      boxShadow: `0px 0px 16px rgba(${hexToRgb(
                        primaryColor,
                      )}, 0.25)`,
                    }}
                  >
                    Next
                  </Buttons>
                )}
              </div>
        
              {/* Background Ellipse Glow */}
              <div className="absolute left-[18rem] h-[24rem] w-[26rem] mix-blend-lighten">
                <div className="absolute inset-[-120%]">
                  <svg className="size-full" fill="none" viewBox="0 0 1250 1210">
                    <g opacity="0.2">
                      <ellipse
                        cx="624.898"
                        cy="604.747"
                        rx="218.898"
                        ry="198.747"
                        fill={primaryColor}
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
        
            {/* Card Inner Shadow */}
            <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />
        
            {/* Card Border */}
            <div
              className="pointer-events-none absolute inset-0 rounded-3xl border"
              style={{
                border: `1.18537px solid ${primaryColor}33`,
                boxShadow: `0px 3.16098px 3.16098px rgba(${hexToRgb(
                  primaryColor,
                )}, 0.12)`,
              }}
            />
          </motion.div>
        </div>
        
        )}
    </>
  );


};




export default CompletionFeedBackScreenFutureTheme;

